import { action, makeObservable, observable } from "mobx";
import JobAPI from "../api/JobAPI";
import { JobRecord } from "../models/Jobs/JobRecord";
import { JobAPIFilters } from "../models/Jobs/JobFilters";

export class JobsStore {
  jobAPI: JobAPI;
  jobs: JobRecord[] = [];
  limit: number;
  total_pages: number;
  total_count: number;

  constructor() {
    this.jobAPI = new JobAPI();
    this.jobs = [];
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;

    makeObservable(this, {
      jobs: observable,
      limit: observable,
      total_pages: observable,
      total_count: observable,
      getJobs: action,
    });
  }

  getJobs = async (filters: JobAPIFilters) => {
    try {
      const response = await this.jobAPI.getJobs(filters);
      this.jobs = response.list;
      this.limit = response.limit;
      this.total_pages = response.total_pages;
      this.total_count = response.total_count;
    } catch (error: any) {
      throw error;
    }
  };
}
